import React from 'react';
import BaseIcon from '@/components/icons/BaseIcon';

const ClockIcon: React.FC = () => (
  <BaseIcon>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12,6 12,12 16,14" />
  </BaseIcon>
);

export default ClockIcon;
